import styled from 'styled-components';
import Button from '@wconcept/wconcept-ui-renewal/components/atoms/Button';
import { mixin } from '@wconcept/wconcept-ui-renewal/styles/index';

export const RelatedPrdItem = styled(Button)`
  position: relative;
  overflow: hidden;
  border-radius: 6px;

  .img {
    border-radius: 6px;
    width: 54px;
    height: 72px;
    background-color: #f6f6f6;
  }

  .total {
    ${mixin.flex({ direction: 'column' })};
    gap: 1px;
    position: absolute;
    z-index: 1;
    background: rgba(0, 0, 0, 0.6);
    width: 110%;
    height: 110%;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    .text {
      font-size: 13px;
      line-height: 130%;
      color: #fff;

      & ~ .text {
        font-size: 11px;
      }
    }

    & + .img {
      background-color: transparent;
    }
  }

  @media ${({ theme }) => theme.media.smMax} {
    gap: ${mixin.pxToVw('5')};
    border-radius: ${mixin.pxToVw('6')};

    .img {
      width: ${mixin.pxToVw('54')};
      height: ${mixin.pxToVw('72')};
    }

    .total {
      .text {
        font-size: ${mixin.pxToVw('13')};
      }
    }
  }
`;
